export const ENTITLEMENT_CONTROL_POLICY_SCHEMA = [
  {
    title: 'Policy Name & Description',
    fields: [
      {
        id: 0,
        label: 'Entitlement Control Policy Name',
        fieldName: 'policyName',
        fieldType: 'TEXT',
        dataType: 'STRING',
        placeholder: 'Entitlement Control Policy Name',
        isValid: true,
        errorMessage: '',
        value: '',
        validations: { required: true },
        fullWidth: true,
      },
      {
        id: 1,
        label: 'Description',
        fieldName: 'description',
        fieldType: 'TEXTAREA',
        dataType: 'STRING',
        placeholder: 'Description',
        isValid: true,
        errorMessage: '',
        value: '',
        validations: { required: true },
        fullWidth: true,
      },
    ],
  },
  {
    title: 'User Specific Parameters',
    fields: [
      {
        id: 2,
        label: 'Applicable Countries',
        saveKey: true,
        fieldName: 'applicableCountries',
        fieldType: 'SELECT',
        dataType: 'STRING',
        placeholder: 'Applicable Countries',
        labelKey: 'value',
        valueKey: 'key',
        isValid: true,
        isMultiple: true,
        errorMessage: '',
        value: [],
        options: [],
        formFieldsOptionsKey: 'countryList',
        validations: { required: true },
        fullWidth: false,
      },
      {
        id: 3,
        label: 'Applicable Platforms',
        saveKey: true,
        fieldName: 'applicablePlatforms',
        fieldType: 'SELECT',
        dataType: 'STRING',
        placeholder: 'Applicable Platforms',
        labelKey: 'value',
        valueKey: 'key',
        isValid: true,
        isMultiple: true,
        errorMessage: '',
        value: [],
        options: [],
        formFieldsOptionsKey: 'platformList',
        validations: { required: true },
        fullWidth: false,
      },
      {
        id: 4,
        label: 'Applicable Partners',
        saveKey: true,
        fieldName: 'applicablePartners',
        fieldType: 'SELECT',
        dataType: 'STRING',
        placeholder: 'Applicable Partners',
        labelKey: 'value',
        valueKey: 'key',
        isValid: true,
        isMultiple: true,
        errorMessage: '',
        value: [],
        options: [],
        formFieldsOptionsKey: 'partnerList',
        validations: { required: true },
        fullWidth: false,
      },
    ],
  },
  {
    title: 'Configuration',
    fields: [
      {
        id: 5,
        label: 'Applicable Entitlement',
        fieldName: 'applicableEntitlement',
        fieldType: 'SELECT',
        dataType: 'STRING',
        placeholder: 'Applicable Entitlement',
        labelKey: 'key',
        valueKey: 'value',
        isValid: true,
        isMultiple: false,
        errorMessage: '',
        value: [],
        options: [],
        formFieldsOptionsKey: 'entitlementList',
        validations: { required: true },
        fullWidth: false,
        clearDependentCondition: [
          {
            fieldIndex: 6,
            fieldValue: null,
            fieldName: 'entitlementChangeType',
          },
        ],
      },
      {
        id: 6,
        label: 'Entitlement Change Type',
        fieldName: 'entitlementChangeType',
        fieldType: 'SELECT',
        dataType: 'STRING',
        placeholder: 'Entitlement Change Type',
        labelKey: 'key',
        valueKey: 'value',
        isValid: true,
        isMultiple: false,
        errorMessage: '',
        value: null,
        options: [],
        formFieldsOptionsKey: 'entitlementChangeTypeList',
        validations: {},
        fullWidth: false,
        visibilityDependentCondition: {
          fieldIndex: 7,
          fieldValue: null,
          fieldName: 'entitlementChangeTimeDifference',
          operator: '!==',
        },
      },
      {
        id: 7,
        isHidden: true,
        label: 'Entitlement Change Time Difference',
        fieldName: 'entitlementChangeTimeDifference',
        fieldType: 'DATETIME',
        dataType: 'NUMBER',
        placeholder: 'Entitlement Change Time Difference',
        isValid: true,
        errorMessage: '',
        value: null,
        validations: { required: true },
      },
      {
        id: 8,
        label: 'Free Preview Duration (seconds) when SVOD',
        fieldName: 'freePreviewDuration',
        fieldType: 'NUMBER',
        dataType: 'NUMBER',
        placeholder: 'Free Preview Duration (seconds) when SVOD',
        isValid: true,
        errorMessage: '',
        value: null,
        validations: { wholeNumber: true },
      },
    ],
  },
]

export const LANGUAGE_CONTROL_POLICY_SCHEMA = [
  {
    title: 'Policy Name & Description',
    fields: [
      {
        id: 0,
        label: 'Language Control Policy Name',
        fieldName: 'policyName',
        fieldType: 'TEXT',
        dataType: 'STRING',
        placeholder: 'Language Control Policy Name',
        isValid: true,
        errorMessage: '',
        value: '',
        validations: { required: true },
        fullWidth: true,
      },
      {
        id: 1,
        label: 'Description',
        fieldName: 'description',
        fieldType: 'TEXTAREA',
        dataType: 'STRING',
        placeholder: 'Description',
        isValid: true,
        errorMessage: '',
        value: '',
        validations: { required: true },
        fullWidth: true,
      },
    ],
  },
  {
    title: 'Language - State Configuration',
    fields: [
      {
        id: 2,
        label: 'Language and State',
        fieldName: 'languageStateConfigurations',
        fieldType: 'JSON1',
        showAddmoreIcon: true,
        addMore: true,
        dataType: 'JSON',
        errorMessage: '',
        validations: {},
        fieldConfig: [
          {
            parentId: 2,
            label: 'Language',
            fieldName: 'applicableLanguage',
            fieldType: 'SELECT',
            dataType: 'STRING',
            placeholder: 'Language',
            labelKey: 'value',
            valueKey: 'key',
            isValid: true,
            isMultiple: false,
            errorMessage: '',
            value: '',
            options: [],
            formFieldsOptionsKey: 'languageList',
            validations: { required: true },
          },
          {
            parentId: 2,
            label: 'State',
            saveKey: true,
            fieldName: 'applicableStates',
            fieldType: 'SELECT',
            dataType: 'STRING',
            placeholder: 'State',
            labelKey: 'value',
            valueKey: 'key',
            isValid: true,
            isMultiple: true,
            errorMessage: '',
            value: [],
            options: [],
            formFieldsOptionsKey: 'stateList',
            validations: { required: true },
          },
        ],
        fields: [],
      },
    ],
  },
]

export const ENTITLEMENT_CONTROL_POLICY_VIEW_SCHEMA = [
  { label: 'Policy Name & Description', key: '', value: '', isHeading: true },
  { label: 'Entitlement Control Policy Name', key: 'policyName', value: '' },
  { label: 'Description', key: 'description', value: '', isWithCount: true },
  { label: 'User Specific Parameters', key: '', value: '', isHeading: true },
  {
    label: 'Applicable Countries',
    key: 'applicableCountries',
    value: '',
    isWithCount: true,
    options: [],
  },
  {
    label: 'Applicable Platforms',
    key: 'applicablePlatforms',
    value: '',
    isWithCount: true,
    options: [],
  },
  {
    label: 'Applicable Partners',
    key: 'applicablePartners',
    value: '',
    isWithCount: true,
    options: [],
  },
  { label: 'Configuration', key: '', value: '', isHeading: true },
  { label: 'Applicable Entitlement', key: 'applicableEntitlement', value: '', isWithCount: true },
  { label: 'Entitlement Change Type', key: 'entitlementChangeType', value: '', isWithCount: true },
  {
    label: 'Entitlement Change Time Difference',
    key: 'entitlementChangeTimeDifference',
    value: '',
  },
  { label: 'Free Preview Duration (seconds) when SVOD', key: 'freePreviewDuration', value: '' },
  { label: 'Applicable Assets', key: '', value: '', isHeading: true },
  { label: 'Content Id', key: 'contentIds', value: '', isWithCount: true },
]

export const LANGUAGE_CONTROL_POLICY_VIEW_SCHEMA = [
  { label: 'Policy Name & Description', key: '', value: '', isTitle: false, isHeading: true },
  { label: 'Language Control Policy Name', key: 'policyName', value: '', isTitle: false },
  { label: 'Description', key: 'description', value: '', isTitle: false, isWithCount: true },
  { label: 'User Specific Parameters', key: '', value: '', isTitle: false, isHeading: true },
  {
    viewType: 'complex',
    label: 'Language and State',
    key: 'languageStateConfigurations',
    columns: [
      {
        id: 'applicableLanguage',
        label: 'Language',
        isRequired: false,
      },
      {
        id: 'applicableStates',
        label: 'State',
        isRequired: false,
      },
    ],
    tableRows: [],
  },
  { label: 'Applicable Assets', key: '', value: '', isTitle: false, isHeading: true },
  {
    label: 'Content Id',
    key: 'contentIds',
    value: '',
    isTitle: false,
    isWithCount: true,
  },
]
